import axios from "axios";

export default {
  state: {
    user: null,
    isLoadingAuthUser: false,
  },
  actions: {
    getAuthUser({commit, state}) {
      state.isLoadingAuthUser = true;
      return axios.get(`/api/v1/me`)
        .then(r => {
          commit("SET_AUTH_USER", r.data.data);
          return r;
        })
        .finally(() => {
          state.isLoadingAuthUser = false;
        });
    },
    logout({commit}){
      axios.get(`/api/v1/logout`)
        .then(() => {
          commit("SET_AUTH_USER", null);
        })
    }
  },
  mutations: {
    SET_AUTH_USER(state, payload) {
      state.user = payload;
    },
    SET_LAST_ACCESS_MODULE(state, payload){
      state.user.last_accessed_module_on_current_cycle = payload;
    }
  },
  getters: {
    authUser: state => state.user,
    hasSchedule: state => state.user.has_schedule,
    hasTrail: (state) =>  !!state.user?.current_trail,
    lastModule: (state) => state.user.last_accessed_module_on_current_cycle,
    lastModuleIsFinished: (state, getters) => getters.hasLastModule && getters.lastModule?.finished_at,
    lastModuleIsUnfinished: (state, getters) => !!getters.lastModule?.finished_at,
    hasLastModule: (state) => !!state.user.last_accessed_module_on_current_cycle,
    currentTrail: (state) => state.user.current_trail,
    report_logs : state => state.user.report_logs,
    view_plan : state => state.user.school.view_plan,
    plan : state => state.user.school.plan,
    new_plan : state => state.user.school.new_plan,
  }
};
